import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import moment from 'moment'
import DatePicker from 'react-mobile-datepicker'

import Wrapper from '../../components/Wrapper'
import Header from '../../components/Header'
import Body from '../../components/Body'
import Footer from '../../components/Footer'
import TopBar from '../../components/TopBar'
import SubmitButton from '../../components/SubmitButton'
import { motorActions } from '../../actions'

import BackgroundImage from '../../assets/images/background.png'
import GroupImage from '../../assets/images/group.png'
import Icon from '@material-ui/core/Icon'
import _ from 'lodash'

import BrandPicker from './../../components/BrandPicker'
import ModelPicker from './../../components/ModelPicker'
import YearPicker from './../../components/YearPicker'

const fontDefault = {
  fontFamily: 'thonburiregular',
  fontStyle: 'normal',
}

const dateStringToText = (inputdate = '0001-01-01') => {
  const date = new Date(inputdate + 'T07:00:00')
  return date.toLocaleDateString('th-TH', {
    month: 'long',
    year: 'numeric',
  })
}

const styles = {
  textTopBar: {
    ...fontDefault,
    color: '#333333',
    fontSize: '18px',
    fontWeight: 'bold',
  },
  backgroundImageContainer: {
    position: 'absolute',
    height: '160px',
    width: '100%',
  },
  backgroundImage: {
    height: '160px',
    objectFit: 'cover',
    width: '100%',
  },
  card: {
    borderRadius: '8px',
    boxShadow: '0 2px 4px 0 rgba(94, 92, 92, 0.3)',
    backgroundImage: 'linear-gradient(162deg, #ffffff, #ffffff)',
    margin: '16px',
  },
  cardHeader: {
    backgroundColor: '#deedfd',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    padding: '16px',
  },
  cardTitle: {
    color: '#0e162c',
    fontSize: '18px',
    ...fontDefault,
  },
  cardContent: {
    padding: '16px',
  },
  container: {
    marginTop: '10px',
    position: 'relative',
  },
  fieldTitle: {
    ...fontDefault,
    fontSize: '16px',
    color: '#0e162c',
  },
  inputContainer: {
    marginTop: '7px',
    padding: '16px',
    borderRadius: '8px',
    boxShadow: '0 1px 4px 0 rgba(157, 157, 157, 0.3)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  inputContainerDisable: {
    marginTop: '7px',
    padding: '16px',
    borderRadius: '8px',
    boxShadow: '0 1px 4px 0 rgba(157, 157, 157, 0.3)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#EFEFEF',
  },
  fieldValueBlank: {
    color: '#cdd2de',
  },
  fieldValue: {
    color: '#0e162c',
  },
  groupContainer: {
    display: 'flex',
    alignItems: 'center',
    padding: '6px 16px 0px 16px',
  },
  groupLogo: {
    width: '56px',
    height: '56px',
  },
  groupText: {
    ...fontDefault,
    fontSize: '18px',
    fontWeight: 'bold',
    color: 'white',
    marginLeft: '16px',
  },
}

class SelectCarModel extends Component {
  state = {
    showBrandPicker: false,
    showModelPicker: false,
    showYearPicker: false,
    isOpenDatePicker: false,
    dateEndError: false,
  }

  backButton = () => {
    const {
      history: { push },
    } = this.props
    const { callbackVersion, currentProduct } = this.props
    if (callbackVersion === 2) {
      if (currentProduct === 'C') {
        push('/select-package')
      } else if (currentProduct === 'V') {
        push('/select-car-model')
      } else {
        push('/home')
      }
    } else {
      push('/home')
    }
    document.getElementById('rootScreen').scrollTo(0, 0)
  }

  goToNextPage = async () => {
    const {
      history: { push },
    } = this.props

    push('/select-package')
    document.getElementById('rootScreen').scrollTo(0, 0)
  }

  componentDidMount = () => {
    const { currentProduct } = this.props
    if (!!currentProduct === false) {
      const {
        history: { push },
      } = this.props
      const { callbackVersion, currentProduct } = this.props
      if (callbackVersion === 2) {
        if (currentProduct === 'C') {
          push('/select-package')
        } else if (currentProduct === 'V') {
          push('/select-car-model')
        } else {
          push('/home')
        }
      } else {
        push('/home')
      }
      document.getElementById('rootScreen').scrollTo(0, 0)
    }
  }

  openBrandPicker = () => {
    this.setState({
      showBrandPicker: true,
    })
  }

  closeBrandPicker = () => {
    this.setState({
      showBrandPicker: false,
    })
  }

  openModelPicker = () => {
    this.setState({
      showModelPicker: true,
    })
  }

  closeModelPicker = () => {
    this.setState({
      showModelPicker: false,
    })
  }

  openYearPicker = () => {
    this.setState({
      showYearPicker: true,
    })
  }

  closeYearPicker = () => {
    this.setState({
      showYearPicker: false,
    })
  }

  render() {
    const {
      currentProduct,
      classes,
      carBrand,
      carModel,
      carYear,
      carEnd,
      callbackVersion,
      setUserInput,
    } = this.props
    const {
      isOpenDatePicker,
      showBrandPicker,
      showModelPicker,
      showYearPicker,
    } = this.state
    let topBarProps = {}
    if (callbackVersion === 2) {
      topBarProps.close = () => {
        window.location.replace('ascendmoney://closewebview')
      }
    } else {
      topBarProps.arrowLeft = this.backButton
    }
    if (currentProduct === 'V') {
      topBarProps.progress = 1
    }
    return (
      <Wrapper>
        <Body style={{ backgroundColor: '#eff0f4' }}>
          <div className={classes.backgroundImageContainer}>
            <img
              alt="background_image"
              className={classes.backgroundImage}
              src={BackgroundImage}
            />
          </div>
          <div className={classes.container}>
            <Grid container>
              <Grid item xs={12}>
                <div className={classes.groupContainer}>
                  <img src={GroupImage} className={classes.groupLogo} />
                  <span className={classes.groupText}>แผนประกันรถยนต์</span>
                </div>
              </Grid>
              <Grid item xs={12}>
                <div className={classes.card}>
                  <div className={classes.cardHeader}>
                    <span className={classes.cardTitle}>ข้อมูลเกี่ยวกับรถ</span>
                  </div>
                  <div className={classes.cardContent}>
                    <div className={classes.fieldContainer}>
                      <span className={classes.fieldTitle}>
                        เลือกยี่ห้อรถยนต์
                      </span>
                      <div
                        className={classes.inputContainer}
                        onClick={this.openBrandPicker}
                      >
                        <span
                          className={
                            carBrand
                              ? classes.fieldValue
                              : classes.fieldValueBlank
                          }
                        >
                          {carBrand ? carBrand : 'เลือก'}
                        </span>
                        <Icon style={{ color: '#4b5161', fontSize: '12px' }}>
                          arrow_forward_ios
                        </Icon>
                      </div>
                    </div>
                    <br />
                    <div
                      className={classes.fieldContainer}
                      onClick={() => {
                        if (carBrand) {
                          this.openModelPicker()
                        }
                      }}
                    >
                      <span className={classes.fieldTitle}>
                        เลือกรุ่นรถยนต์
                      </span>
                      <div
                        className={
                          carBrand
                            ? classes.inputContainer
                            : classes.inputContainerDisable
                        }
                      >
                        <span
                          className={
                            carModel
                              ? classes.fieldValue
                              : classes.fieldValueBlank
                          }
                        >
                          {carModel ? _.get(carModel, 'label', '') : 'เลือก'}
                        </span>
                        <Icon style={{ color: '#4b5161', fontSize: '12px' }}>
                          arrow_forward_ios
                        </Icon>
                      </div>
                    </div>
                    <br />
                    <div
                      className={classes.fieldContainer}
                      onClick={() => {
                        if (carBrand && carModel) {
                          this.openYearPicker()
                        }
                      }}
                    >
                      <span className={classes.fieldTitle}>
                        เลือกปีที่จดทะเบียน
                      </span>
                      <div
                        className={
                          carBrand && carModel
                            ? classes.inputContainer
                            : classes.inputContainerDisable
                        }
                      >
                        <span
                          className={
                            carYear
                              ? classes.fieldValue
                              : classes.fieldValueBlank
                          }
                        >
                          {carYear ? carYear : 'เลือก'}
                        </span>
                        <Icon style={{ color: '#4b5161', fontSize: '12px' }}>
                          arrow_forward_ios
                        </Icon>
                      </div>
                    </div>
                    <br />
                    <div
                      className={classes.fieldContainer}
                      onClick={() => {
                          this.setState({
                            isOpenDatePicker: true,
                          })
                          // this.openYearPicker()
                      }}
                    >
                      <span className={classes.fieldTitle}>
      คุณต้องการเริ่มต้นความคุ้มครองเมื่อไหร่?
                      </span>
                      <div
                        className={
                             classes.inputContainer
                        }
                      >
                        <span
                          className={
                            carEnd
                              ? classes.fieldValue
                              : classes.fieldValueBlank
                          }
                        >
                          {carEnd ? dateStringToText(carEnd) : 'เลือก'}
                        </span>
                        <Icon style={{ color: '#4b5161', fontSize: '12px' }}>
                          arrow_forward_ios
                        </Icon>
                      </div>
                    </div>
                    <br />
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
          <BrandPicker
            open={showBrandPicker}
            onBack={this.closeBrandPicker}
            history={this.props.history}
          />
          <ModelPicker
            open={showModelPicker}
            onBack={this.closeModelPicker}
            history={this.props.history}
          />
          <YearPicker
            open={showYearPicker}
            onBack={this.closeYearPicker}
            history={this.props.history}
          />
        </Body>
        <DatePicker
          value={carEnd ? new Date(carEnd + 'T07:00:00') : new Date()}
          isOpen={isOpenDatePicker}
          onSelect={time => {
            setUserInput({ carEnd: moment(time).format('YYYY-MM-DD') })
            this.setState({
              isOpenDatePicker: false,
              dateEndError: false,
            })
          }}
          onCancel={() => {
            this.setState({
              isOpenDatePicker: false,
            })
          }}
          confirmText="ตกลง"
          cancelText="ยกเลิก"
          showHeader={false}
          showCaption
          min={moment()
            .subtract(1, 'year')
            .toDate()}
          max={moment()
            .add(1, 'year')
            .toDate()}
          dateConfig={{
            month: {
              format: 'MMMM',
              caption: 'เดือน',
              step: 1,
            },
            year: {
              format: 'YYYYY',
              caption: 'ปี',
              step: 1,
            },
          }}
        />
        <Footer style={{ backgroundColor: '#eff0f4' }}>
          <SubmitButton
            onClick={() => {
              if (carBrand && carModel && carYear) {
                this.goToNextPage()
              }
            }}
          >
            เช็คราคา
          </SubmitButton>
        </Footer>
        <Header>
          <TopBar {...topBarProps}>
            <Typography align="center" className={classes.textTopBar}>
              เลือกประเภท
            </Typography>
          </TopBar>
        </Header>
      </Wrapper>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentProduct: _.get(state, 'motor.userInput.currentProduct', ''),
    carBrand: _.get(state, 'motor.userInput.carBrand', ''),
    carModel: _.get(state, 'motor.userInput.carModel', ''),
    carYear: _.get(state, 'motor.userInput.carYear', ''),
    carEnd: _.get(state, 'motor.userInput.carEnd', ''),
    callbackVersion: _.get(state, 'motor.userInput.callbackVersion', 1),
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setPackage: (data, policyTypes, registerYear) =>
      dispatch(motorActions.setPackage(data, policyTypes, registerYear)),
    setUserInput: data => {
      dispatch({
        type: 'USER_INPUT',
        data,
      })
    },
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(SelectCarModel))
